import H2 from "../components/H2"
import ContactForm from "../components/forms/ContactForm"
import ContactSidebar from "../components/ContactSidebar"

export default function Contact() {
  return (
    <div className="flex flex-wrap mb-20 lg:mb-32">
      <div className="w-full md:w-2/3">
        <H2 title="Contact us" />
        <ContactForm />
      </div>
      <ContactSidebar />
    </div>
  );
}